import * as api from '@pointOfSale/api';
import * as MutationTypes from '../mutationTypes';

export const newProductsRequest = async ({ commit, getters: { newProducts } }, pointOfSaleGuid) => {
  if (newProducts === null) {
    const response = await api.newProductsRequest(pointOfSaleGuid);
    commit(MutationTypes.NEW_PRODUCTS_SUCCESS, response.data);
  }
};

export const modifyNewProducts = async ({ commit, getters: { newProducts }, dispatch }, increment) => {
  commit(MutationTypes.MODIFY_NEW_PRODUCTS, increment);
  if (newProducts <= 0) {
    await dispatch('removeNotificationById', 'newItems');
  }
};
